import { Injectable } from "@angular/core";
import { Adapter } from "./adapter";

export class DocType {
    public DocType_ID = null;
    public DocType_Code = null;
    public DocType_Name = null;
    public Active = null;
    public Parent_DocType_Code = null;
    public CreatedBy = null;
    public CreatedOn = null;
    public ModifiedBy = null;
    public ModifiedOn = null;

    // constructor(public DocType_ID, public DocType_Code, public DocType_Name, public Active, public Parent_DocType_Code, public CreatedBy, public CreatedOn, public ModifiedBy, public ModifiedOn) {
        // this.DocType_ID = fields.DocType_ID;
        // return fields;
    // }

    constructor(public initVal: Partial<DocType>) {
        Object.assign(this, initVal);
    }
}

@Injectable()
export class DocTypeAdapter implements Adapter<DocType> {
    adapt(item: any): DocType {
        return new DocType(item);
    }
}